import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import DrawerAppBar from "../components/common/navbar/drawerAppBar"
import PageTitle from "../components/common/pageTitle/pageTitle"
import Footer from "../components/common/footer/footer"
import SidebarLinks from "../components/common/sidebarLinks/sidebarLinks"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import Container from "@mui/material/Container"
import AboutContent from "../components/common/aboutContent/aboutContent"
import useWindowDimensions from "../hooks/useWindowDimensions"

import "./about.css"

const sidebarLinks = [
    {
        label: "Eqdom",
        value: 1,
    },
    {
        label: "Présentation de nos Administrateurs",
        value: 2,
    },
]



const members = [
    { name: "Monsieur Moulay M'Hamed ELALAMY", role: "Président du Conseil d'Administration" },
    { name: 'Monsieur Moulay Abdelaziz Ali ELALAMY ', role: 'Administrateur' },
    { name: 'Madame Fadwa BEN SAAD ', role: 'Administratrice' },
    { name: 'Monsieur Ahmed EL YACOUBI', role: 'Administrateur' },
    { name: 'Saham Bank (représentée par Madame Asmaa HAJJAMI)', role: 'Administratrice' },
    { name: 'Monsieur Mohammed TAHRI', role: 'Administrateur' },
    { name: 'Monsieur Abdelaziz TAZI ', role: 'Administrateur' },
    { name: 'Monsieur Yassine SEKKAT', role: 'Administrateur' },
    { name: 'Monsieur Abdelhalim FADIL', role: 'Administrateur' },
    { name: 'Caisse Interprofessionnelle Marocaine de Retraite (représentée par Monsieur Hassan BOULAKNADAL)', role: 'Administrateur' },
    { name: 'Société ATLANTIC RE (Ex SCR) : représentée par Madame Ouafae MRIOUAH', role: 'Administratrice' },
    { name: 'Madame Amina FIGUIGUI', role: 'Administratrice Indépendante' },
    { name: 'Madame Kawtar JOHRATI', role: 'Administratrice Indépendante' },
]; 


const About = () => {
    const [currentSection, setCurrentSection] = useState(1)
    const { t } = useTranslation()
    const { width } = useWindowDimensions()

    const handleOnClickSideLinks = (value) => {
        setCurrentSection(value)
    }

    const renderPageTitle = () => {
        switch (currentSection) {
            case 1:
                return t("a_propos_title")
            case 2:
                return t("actionnariat_title")
            default:
                return null
        }
    }

    return (
        <>
            <div style={{ position: "relative", minHeight: "100vh" }}>
                <DrawerAppBar />

                <Container
                    maxWidth="lg"
                    {...(width < 1500
                        ? { sx: { marginLeft:"auto",paddingBottom: "20em" } }
                        : { sx: { marginLeft:"10px",paddingBottom: "10em" } })
                    }
                >
                    <Box sx={{ flexGrow: 1 }}>
                        {/* Title Section */}
                        <Grid item md={12}>
                            <PageTitle title={t("aboutPageTitle")} />
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item md={4}>
                                <SidebarLinks
                                    links={sidebarLinks}
                                    currentUuid={currentSection}
                                    handleOnClick={handleOnClickSideLinks}
                                />
                            </Grid>

                            <Grid item md={8}>
                                <Box sx={{ width: "100%" }}>
                                    <h1
                                        style={{
                                            marginTop: 0,
                                            fontWeight: 400,
                                        }}
                                    >
                                        {renderPageTitle()}
                                    </h1>
                                    {currentSection === 1 ? (
                                        <AboutContent />
                                    ) : (
                                        <div className="table-container">
                                        <table className="custom-table">
                                          <tbody>
                                            {members.map((member, index) => (
                                              <tr key={index}>
                                                <td>{member.name}</td>
                                                <td className="custom-table-role">{member.role}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Footer />
            </div>
        </>
    )
}

export default About
